import { Prism } from '@mantine/prism';

export function JsonViewer({ value }: { value: unknown }) {
    return <Prism language={'json'}>{JSON.stringify(value, null, 2)}</Prism>;
}
